// import 'rxjs/add/operator/do';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";
import {Router } from "@angular/router";
import { Injectable } from '@angular/core';
import { HelperService } from '../../storage-helper';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _router: Router, private _helper: HelperService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if(err.status == 401 && err.statusText == "Unauthorized") {
          // redirect to the login route
          // or show a modal
          this._helper.removeFromLocal("currentUserCS");
          this._helper.removeFromLocal("isLoggedIn");
          this._router.navigate(['/api/login']);

        }
      }
    }));
  }
}